(function () {
    'use strict';

    angular.module("imApp").factory("acReportLayoutsService", [function () {
        let service = {};

        return service;
    }]);
})();
